import {STATE_PROP_NAME} from './share-article-modal-constants'

export const getState = state => state[STATE_PROP_NAME]
